import "./FractionalSeoConsultant.module.css";
import Header from "@/reusable_sections/Header";
import FractionalHero from "./sections/FractionalHero";
import Fractional from "./sections/Fractional";
import WhyFractional from "./sections/WhyFractional";
import Process from "./sections/Process";
import Differentiators from "./sections/Differentiators";
import ProvenResults from "./sections/ProvenResults";
import TargetAudience from "./sections/TargetAudience";
import FractionalPricing from "./sections/FractionalPricing";
import Faq from "./sections/Faq";
import Conversion from "./sections/Conversion";
import Footer from "@/reusable_sections/Footer";
export default function FractionalSeoConsultantPage() {
  return <div>
      <Header />
      <FractionalHero />
      <Fractional />
      <WhyFractional />
      <Process />
      <Differentiators />
      <ProvenResults />
      <TargetAudience />
      <FractionalPricing />
      <Faq />
      <Conversion />
      <Footer />
    </div>;
}